export default __webpack_public_path__ + "static/media/trash-blue.492e4bdf.svg";